module.exports = __webpack_public_path__ + "static/img/page_READ01.1b9bcc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series4/course-rm-02/page_READ01.png
// module id = tCGD
// module chunks = 0